var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"9hLOc3xpryqbrSGuSjJ8t"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// * File commented for now, as we are not using Sentry in this project at the moment.
// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

// import * as Sentry from '@sentry/nextjs';

// const SENTRY_ENABLED_ENVIRONMENTS = ['production', 'staging'];

// Sentry.init({
//   dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,

//   // Add optional integrations for additional features
//   integrations: [
//     Sentry.replayIntegration({
//       maskAllText: false,
//     }),
//   ],

//   // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
//   tracesSampleRate:
//     process.env.NEXT_PUBLIC_NODE_ENV === 'production' ? 0.1 : 1.0,

//   // Define how likely Replay events are sampled.
//   // This sets the sample rate to be 10%. You may want this to be 100% while
//   // in development and sample at a lower rate in production
//   replaysSessionSampleRate: 0.1,

//   // Define how likely Replay events are sampled when an error occurs.
//   replaysOnErrorSampleRate: 1.0,

//   // Setting this option to true will print useful information to the console while you're setting up Sentry.
//   debug: false,
//   environment: process.env.NEXT_PUBLIC_NODE_ENV,
//   enabled:
//     process.env.NEXT_PUBLIC_NODE_ENV != null &&
//     SENTRY_ENABLED_ENVIRONMENTS.includes(process.env.NEXT_PUBLIC_NODE_ENV),
// });

export {}